export default {
  appName: 'Autohaus Manager',
  logo: '/alzuraLogo.png',
  logoLight: '/alzuraLogo-light.png',
  primary: '#002a91',
};
